import SelectLabelFormatter from '../SelectLabelFormatter'

import AirportWFFMDataExchange from '@/services/AirportWFFMDataExchange'

/**
 * A mixin adding airport editing logic and data
 */
export default {
  mixins: [
    SelectLabelFormatter,
  ],
  data () {
    return {
      dx: { airport: new AirportWFFMDataExchange(this.form) },
      popups: { airport: false },
      airports: [],
      allAirportsSelected: false,
    }
  },
  mounted () {
    this.airports = this.dx.airport.data
  },
  computed: {
    airportsEnabled () {
      return this.airports.filter(airport => airport.enabled)
    },
    anyAirportEnabled () {
      return this.airports.some(airport => airport.enabled)
    },
    selectedAirports () {
      return this.airports.filter(airport => airport.selected)
    },
    selectedAirportLabel () {
      return this.getFormattedSelectLabel(this.selectedAirports, 'Wylot z...')
    },
    selectedAirportValue () {
      return this.getFormattedSelectValue(this.selectedAirports, 'Dowolne lotnisko')
    },
  },
  methods: {
    allAirportsToggleSelected (selected) {
      this.allAirportsSelected = selected
      this.updateAndReselectList('destinations')
    },
  },
}



// WEBPACK FOOTER //
// ./src/components/search/logic/Airport.js